import OpenInNew from '@mui/icons-material/OpenInNew'
import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'
import { NavLink } from 'react-router-dom'
import '../styles/SideBar.scss'

/**
 * Generate a SideBareMenuItems with this.
 * @param props SidebarMenuItem, links yms.
 * @returns Ready to add sidebarmenuitem
 */

export interface SideBarItem {
  link: string
  icon?: JSX.Element
  text: string
  isExact?: boolean
  dataTestId?: string
  ariaLabel?: string
  disabled?: boolean
  isNested?: boolean
  nestedItems?: SideBarItem[]
  styleName?: string
  activeStyle?: string
  menuID?: string
  nestFont?: boolean
  isExternal?: boolean
}

export const SideBarItem = (props: SideBarItem): JSX.Element => {
  const { link, icon, text, dataTestId, ariaLabel, disabled, styleName, activeStyle = '', isExact = false, isExternal = false } = props
  type ExternalProps = { component: 'a'; href: string; target: string; rel: string }
  type InternalProps = { component: typeof NavLink; to: string; exact: boolean; activeClassName: string }
  const buttonProps: ExternalProps | InternalProps = isExternal
    ? {
        component: 'a',
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {
        component: NavLink,
        to: link,
        exact: isExact,
        activeClassName: styleName + activeStyle,
      }

  return (
    <ListItem key={text} className='listItemStyling' disablePadding aria-label={ariaLabel} data-testid={dataTestId}>
      <ListItemButton {...buttonProps} className={styleName} disabled={disabled} disableRipple>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={
            isExternal ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {text}
                <OpenInNew sx={{ fontSize: 16, opacity: 0.7 }} />
              </Box>
            ) : (
              text
            )
          }
        />
      </ListItemButton>
    </ListItem>
  )
}
